import React, { useRef } from "react";
import ct from "class-types.macro";
import { BannerType } from "../definitions";
import SpotlightProductInfo from "../ProductInfo";
import SpotlightHeader from "../Header";
import useIsMounted from "~/common/useIsMounted";
import { User } from "~/common/Store/models/User";
import { SpotlightBannerItem } from "../../../ProductDetailPageResult";
import { getDestinationItemNumber, sendCtrEvent } from "~/analytics/ClickThroughRateTracking/clickThroughRateHelpers";
import { useCtrImpressionTracking } from "../../../../analytics/ClickThroughRateTracking/useCtrImpressionTracking";
interface Props {
  item: SpotlightBannerItem;
  bannerType: BannerType;
  currentProductTitle?: string;
  user: User;
  originalLinkingItemNumber: string;
}
const SingleProduct = ({
  item,
  bannerType,
  user,
  originalLinkingItemNumber
}: Props) => {
  const isMounted = useIsMounted();
  const ctrProps = {
    destination: getDestinationItemNumber(bannerType, item),
    source: originalLinkingItemNumber,
    type: bannerType
  };
  let bannerMessage = "";
  if (bannerType === BannerType.GoodBetterBest) {
    bannerMessage = "Looking for an upgrade?";
  }
  if (bannerType === BannerType.SideBySide) {
    if (item.bannerMessage) {
      bannerMessage = item.bannerMessage;
    }
    if (item.headlineText && !item.isRecommendedSimilarItem) {
      bannerMessage = item.headlineText;
    }
  }
  const productRef = useRef<HTMLDivElement>(null);
  useCtrImpressionTracking(productRef, ctrProps);
  return <>
      <SpotlightHeader bannerMessage={bannerMessage} data-sentry-element="SpotlightHeader" data-sentry-source-file="index.tsx" />
      <div className={ct("flex", "justify-between", "overflow-x-auto", "w-full")} ref={productRef}>
        <SpotlightProductInfo originalLinkingItemNumber={originalLinkingItemNumber} item={item} bannerType={bannerType} mounted={isMounted} user={user} data-sentry-element="SpotlightProductInfo" data-sentry-source-file="index.tsx" />
        <div className={ct("hidden", "flex-col", "items-center", "justify-center", "flex-shrink-0", "p-4", "sm:flex")}>
          <a href={item.link} onClick={() => {
          sendCtrEvent("Click", ctrProps);
        }} className={`${ct("rounded-normal", "border-solid", "border", "box-border", "cursor-pointer", "inline-block", "font-semibold", "text-base", "py-4", "px-5", "px-7", "py-2-1/2", "text-center", "text-white", "no-underline", "hover:no-underline", "antialiased", "align-middle", "bg-green-500", "hover:bg-green-800", "border-black-25")} focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-green-800 active:shadow-inset-black-15`}>
            View Product
          </a>
        </div>
      </div>
    </>;
};
export default SingleProduct;